import { cleanClass } from '@shared/utils/cleanClass.js';
import PageActionRow from './PageActionRow.jsx';
import PageCard from './PageCard.jsx';
import PageDescription from './PageDescription.jsx';
import PageGroup from './PageGroup.jsx';
import PageHeader from './PageHeader.jsx';
import PageInput from './PageInput.jsx';
import PageLoading from './PageLoading.jsx';
import PageSearch from './PageSearch.jsx';
import PageSection from './PageSection.jsx';
import PageSections from './PageSections.jsx';
import PageSelect from './PageSelect.jsx';
import PageSplitGroup from './PageSplitGroup.jsx';
import PageSubtitle from './PageSubtitle.jsx';
import PageTable from './PageTable.jsx';
import PageTableFloatingMenu from './PageTableFloatingMenu.jsx';
import PageTableKeyHandler from './PageTableKeyHandler.jsx';
import PageTabs from './PageTabs.jsx';
import PageTitle from './PageTitle.jsx';
import PageToggle from './PageToggle.jsx';
import PageWrapper from './PageWrapper.jsx';
import PageWrapperWithNav from './PageWrapperWithNav.jsx';
import PageWrapperWithPanes from './PageWrapperWithPanes.jsx';

// TODO: Add ScrollContainerV2 as a prop
const Page = ({ children, className }) => {
  return <div className={cleanClass(`comp-page ${className || ''}`)}>{children}</div>;
};

const PageContent = ({ children }) => {
  return <div className="comp-page-content">{children}</div>;
};

const PageBaseWrapper = ({ children, name = '', className = '' }) => {
  return <div className={cleanClass(`comp-page-wrapper ${name} ${className}`)}>{children}</div>;
};

Page.Header = PageHeader;
Page.Title = PageTitle;
Page.Tabs = PageTabs;
Page.Sections = PageSections;
Page.Section = PageSection;
Page.Input = PageInput;
Page.Select = PageSelect;
Page.Description = PageDescription;
Page.Subtitle = PageSubtitle;
Page.Search = PageSearch;
Page.ActionRow = PageActionRow;
Page.Group = PageGroup;
Page.SplitGroup = PageSplitGroup;
Page.Table = PageTable;
Page.TableKeyHandler = PageTableKeyHandler;
Page.TableFloatingMenu = PageTableFloatingMenu;
Page.Loading = PageLoading;
Page.Toggle = PageToggle;
Page.BaseWrapper = PageBaseWrapper;
Page.Wrapper = PageWrapper;
Page.WrapperWithNav = PageWrapperWithNav;
Page.WrapperWithPanes = PageWrapperWithPanes;
Page.Card = PageCard;
Page.Content = PageContent;

export default Page;
